import React, { useState, useEffect } from 'react';
import { Menu, MenuItem, MenuDivider, InputGroup } from '@blueprintjs/core'
import U from '../Utilities/Utilities'

export default (props) => {

    const [filter, setFilter] = useState('');

    const selected = props.countries.filter((c) => props.selected.indexOf(c.id) > - 1);

    return (
        <>
            <InputGroup
                large
                placeholder={'Filter'}
                leftIcon={'search'}
                onChange={(e) => {
                    setFilter(e.target.value)
                }}
            />
            <Menu style={{
                maxHeight: '75vh',
                overflow: 'auto'
            }}>
                {selected.length > 0 && <MenuItem text={'Selected'} large />}
                {selected.map((c) => (
                    <MenuItem
                        text={<div dangerouslySetInnerHTML={{ __html: `&nbsp;&nbsp;&nbsp;&nbsp;${c.name.replace(/&nbsp;/g, '')}` }} />}
                        large
                        active
                        onClick={() => {
                            if (window.confirm('Remove?')) {
                                props.onClick && props.onClick(c);
                            }
                        }}
                    />
                ))}
                {selected.length > 0 && <MenuDivider />}
                {props.countries.filter((country) => (filter.length == 0 || U.startsWith(country.name, filter))).map((country) => (
                    <MenuItem
                        text={<div dangerouslySetInnerHTML={{ __html: country.name }}></div>}
                        large
                        active={props.selected && props.selected.indexOf(country.id) > -1}
                        onClick={() => {
                            props.onClick && props.onClick(country);
                        }}
                    />
                ))}
            </Menu>
        </>
    )

}